import React from 'react';
import {ruleTriggerDetails} from './expressionEditorModel';
export default function RuleTriggerSummary({steps,variables}){
  const details=ruleTriggerDetails(steps,variables);
  return <div className="logic-trigger-summary">
    <strong>Runs whenever the calculator recalculates</strong>
    <p>No separate trigger condition is configured. Any conditions inside the formula choose the calculated value.</p>
    {details.dependencies.length>0&&<p><strong>Uses:</strong> {details.dependencies.join(', ')}</p>}
    {details.conditions.length>0&&<div><strong>Conditions inside the formula</strong><ul>{details.conditions.map((condition,index)=><li key={index}>{condition}</li>)}</ul></div>}
    {details.bands.map((band,index)=><div key={index}><strong>How the formula chooses a value</strong><p>{band.label}</p><table className="logic-trigger-table"><thead><tr><th>Input condition</th><th>Result</th></tr></thead><tbody>{band.rows.map((row,i)=><tr key={i}><td>{row.condition}</td><td>{String(row.value)}</td></tr>)}</tbody></table></div>)}
  </div>;
}
